/**
 * Usage Reports Reducer
 * NgRx reducer for usage reports state management
 */
import { createReducer, on } from '@ngrx/store';
import { UsageReportState, initialUsageReportState } from '../models/usage-reports.models';
import * as UsageReportsActions from './usage-reports.actions';

export const usageReportsReducer = createReducer(
  initialUsageReportState,

  // Load Usage Stats
  on(UsageReportsActions.loadUsageStats, (state) => ({
    ...state,
    loading: true,
    error: null
  })),
  on(UsageReportsActions.loadUsageStatsSuccess, (state, { stats }) => ({
    ...state,
    stats,
    loading: false
  })),
  on(UsageReportsActions.loadUsageStatsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Load Daily Usage
  on(UsageReportsActions.loadDailyUsage, (state) => ({
    ...state,
    loading: true,
    error: null
  })),
  on(UsageReportsActions.loadDailyUsageSuccess, (state, { dailyUsage }) => ({
    ...state,
    dailyUsage,
    loading: false
  })),
  on(UsageReportsActions.loadDailyUsageFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Load Processing Logs
  on(UsageReportsActions.loadProcessingLogs, (state) => ({
    ...state,
    loading: true,
    error: null
  })),
  on(UsageReportsActions.loadProcessingLogsSuccess, (state, { logs, total }) => ({
    ...state,
    processingLogs: logs,
    totalLogs: total,
    loading: false
  })),
  on(UsageReportsActions.loadProcessingLogsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Update Filters
  on(UsageReportsActions.updateFilters, (state, { filters }) => ({
    ...state,
    filters: { ...state.filters, ...filters },
    currentPage: 1
  })),

  // Pagination
  on(UsageReportsActions.changePage, (state, { page }) => ({
    ...state,
    currentPage: page
  })),
  on(UsageReportsActions.changePageSize, (state, { pageSize }) => ({
    ...state,
    pageSize,
    currentPage: 1
  })),

  // Export
  on(UsageReportsActions.exportReport, (state) => ({
    ...state,
    exporting: true
  })),
  on(UsageReportsActions.exportReportSuccess, (state) => ({
    ...state,
    exporting: false
  })),
  on(UsageReportsActions.exportReportFailure, (state, { error }) => ({
    ...state,
    exporting: false,
    error
  })),

  // Clear Error
  on(UsageReportsActions.clearError, (state) => ({
    ...state,
    error: null
  }))
);

